module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAGFBMVEVHcEzDxsrDx8zFx8rExsrFx8rExsrExspko6kWAAAAB3RSTlMA8DcmymztXWXOzQAAAIxJREFUGNNdkTsOgzAQREeBcAA3tHCDSCDRInEBqtRpcgArxVw/7K6N5HHjHb31fsYAFpTjwZtHqJVf4EnmydRjJE8MJJPJ+Qo+2BjYIH8uDRu8ZE/HDrmj8zs5zK+SlcfyJmqQrA3nKr3fjQPeOJXRA1eosk2WUm0jGaMdUlaQBWV9MUesE2PF9vZT/nO1YPUnloG2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/InvitePoster/img/close.png
// module id = 685
// module chunks = 1